import Cookies from 'js-cookie';
import { onCLS, onFID, onLCP, onTTFB, onFCP, onINP } from 'web-vitals';

const constants = {
  COMPANY_PREFIX: {
    NEXCESS: "nx",
    LIQUID_WEB: "lw"
  },
  EVENTS: {
    PAGEVIEW: "lw.pageview",
    VIRTUAL_PAGEVIEW: "lw.pageviewVirtual",
    IDENTIFY: "lw.identify",
    STRUCTURED: "lw.structured",
    VITALS: "lw.webVitals",
    TIMING: "lw.timing",
    CHAT: {
      INVITATION: {
        DISPLAYED: "invitation_displayed",
        DISMISSED: "invitation_dismissed",
        ACCEPTED: "invitation_accepted"
      }
    },
    ECOMMERCE: {
      LW: "lw.ecommerce",
      ADD_TO_CART: "add_to_cart",
      PURCHASE: "purchase",
      BEGIN_CHECKOUT: "begin_checkout",
      ADD_PAYMENT_INFO: "add_payment_info",
      VIEW_PROMOTION: "view_promotion",
      SELECT_PROMOTION: "select_promotion",
      ACTIONS: {
        ADD_TO_CART: "PREFIX:cartItem_added",
        PURCHASE_COMPLETED: "PREFIX:purchase_completed",
        CHECKOUT_PROGRESSED: "PREFIX:checkout_progressed",
        PROMOTION_VIEWED: "PREFIX:promotion_viewed",
        PROMOTION_CLICKED: "PREFIX:promotion_clicked"
      }
    }
  },
  DIMENSIONS: {
    USER_TYPE: "lw.userType"
  },
  COOKIES: {
    USER: "user-data"
  },
  NEXCESS: {
    CHECKOUT_STEPS: {
      STARTED: 1,
      TERMS_AGREEMENT: 2,
      SIGNUP: 3,
      PLAN_DETAILS: 4,
      BILLING_INFO: 5,
      PURCHASE_INITIATED: 6
    }
  }
};

function user({
  clientName,
  cloudServerCount,
  colocationCount,
  dedicatedServerCount,
  isPartner,
  planCount,
  resellerHostingCount,
  sharedHostingCount,
  ticketCount
} = {}) {
  return {
    clientName,
    cloudServerCount,
    colocationCount,
    dedicatedServerCount,
    isPartner,
    planCount,
    resellerHostingCount,
    sharedHostingCount,
    ticketCount
  };
}

function getUserCookieName(companyPrefix) {
  return `${companyPrefix}-${constants.COOKIES.USER}`;
}
function getDomain(hostname) {
  const parts = hostname.split(".").reverse();
  return parts.length > 1 ? `${parts[1]}.${parts[0]}` : hostname;
}
function setUser(companyPrefix, data = {}) {
  return Cookies.set(getUserCookieName(companyPrefix), JSON.stringify(user(data)), {
    expires: 730,
    domain: getDomain(window.location.hostname)
  });
}
function getUser(companyPrefix) {
  let userData = {};
  try {
    userData = JSON.parse(Cookies.get(getUserCookieName(companyPrefix)));
  } catch (e) {
  }
  return userData;
}

var cookies = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setUser: setUser,
  getUser: getUser
});

var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
var root = freeGlobal || freeSelf || Function('return this')();

var Symbol = root.Symbol;

var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
var nativeObjectToString = objectProto.toString;
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];
  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var objectProto$1 = Object.prototype;
var nativeObjectToString$1 = objectProto$1.toString;
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
var symToStringTag$1 = Symbol ? Symbol.toStringTag : undefined;
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag$1 && symToStringTag$1 in Object(value) ? getRawTag(value) : objectToString(value);
}

function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isArray = Array.isArray;

function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

function identity(value) {
  return value;
}

var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var coreJsData = root['__core-js_shared__'];

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

var funcProto = Function.prototype;
var funcToString = funcProto.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;
var funcToString$1 = funcProto$1.toString;
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

function getValue(object, key) {
  return object == null ? undefined : object[key];
}

function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

var WeakMap = getNative(root, 'WeakMap');

var objectCreate = Object.create;
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

function copyArray(source, array) {
  var index = -1,
      length = source.length;
  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;
  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var MAX_SAFE_INTEGER = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

function eq(value, other) {
  return value === other || value !== value && other !== other;
}

var objectProto$3 = Object.prototype;
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$2.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
      length = props.length;
  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

var MAX_SAFE_INTEGER$1 = 9007199254740991;
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

var objectProto$4 = Object.prototype;
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$4;
  return value === proto;
}

function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var argsTag = '[object Arguments]';
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

var objectProto$5 = Object.prototype;
var hasOwnProperty$3 = objectProto$5.hasOwnProperty;
var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;
var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty$3.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};

function stubFalse() {
  return false;
}

var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var Buffer = moduleExports ? root.Buffer : undefined;
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
var isBuffer = nativeIsBuffer || stubFalse;

var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var freeProcess = moduleExports$1 && freeGlobal.process;
var nodeUtil = function () {
  try {
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;
    if (types) {
      return types;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

var objectProto$6 = Object.prototype;
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$4.call(value, key)) && !(skipIndexes && (
    key == 'length' ||
    isBuff && (key == 'offset' || key == 'parent') ||
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

var nativeKeys = overArg(Object.keys, Object);

var objectProto$7 = Object.prototype;
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$5.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var objectProto$8 = Object.prototype;
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];
  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$6.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

function keysIn$1(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

var nativeCreate = getNative(Object, 'create');

function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var HASH_UNDEFINED = '__lodash_hash_undefined__';
var objectProto$9 = Object.prototype;
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$7.call(data, key) ? data[key] : undefined;
}

var objectProto$a = Object.prototype;
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty$8.call(data, key);
}

var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}

function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

var Map = getNative(root, 'Map');

function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var getPrototype = overArg(Object.getPrototypeOf, Object);

function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);
  this.size = data.size;
  return result;
}

function stackGet(key) {
  return this.__data__.get(key);
}

function stackHas(key) {
  return this.__data__.has(key);
}

var LARGE_ARRAY_SIZE = 200;
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn$1(source), object);
}

var freeExports$2 = typeof exports == 'object' && exports && !exports.nodeType && exports;
var freeModule$2 = freeExports$2 && typeof module == 'object' && module && !module.nodeType && module;
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
var Buffer$1 = moduleExports$2 ? root.Buffer : undefined,
    allocUnsafe = Buffer$1 ? Buffer$1.allocUnsafe : undefined;
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}

function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

function stubArray() {
  return [];
}

var objectProto$b = Object.prototype;
var propertyIsEnumerable$1 = objectProto$b.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};

function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
var getSymbolsIn = !nativeGetSymbols$1 ? stubArray : function (object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn$1, getSymbolsIn);
}

var DataView = getNative(root, 'DataView');

var Promise = getNative(root, 'Promise');

var Set = getNative(root, 'Set');

var mapTag$1 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$1 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';
var dataViewTag$1 = '[object DataView]';
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);
var getTag = baseGetTag;
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag$1 || Map && getTag(new Map()) != mapTag$1 || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag$1 || WeakMap && getTag(new WeakMap()) != weakMapTag$1) {
  getTag = function (value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$1;
        case mapCtorString:
          return mapTag$1;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$1;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result;
  };
}
var getTag$1 = getTag;

var objectProto$c = Object.prototype;
var hasOwnProperty$9 = objectProto$c.hasOwnProperty;
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);
  if (length && typeof array[0] == 'string' && hasOwnProperty$9.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var Uint8Array = root.Uint8Array;

function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var reFlags = /\w*$/;
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag = '[object Symbol]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);
    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);
    case dataViewTag$2:
      return cloneDataView(object, isDeep);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object, isDeep);
    case mapTag$2:
      return new Ctor();
    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);
    case regexpTag$1:
      return cloneRegExp(object);
    case setTag$2:
      return new Ctor();
    case symbolTag:
      return cloneSymbol(object);
  }
}

function initCloneObject(object) {
  return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}

var mapTag$3 = '[object Map]';
function baseIsMap(value) {
  return isObjectLike(value) && getTag$1(value) == mapTag$3;
}

var nodeIsMap = nodeUtil && nodeUtil.isMap;
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

var setTag$3 = '[object Set]';
function baseIsSet(value) {
  return isObjectLike(value) && getTag$1(value) == setTag$3;
}

var nodeIsSet = nodeUtil && nodeUtil.isSet;
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;
var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$1 = '[object Symbol]',
    weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';
var cloneableTags = {};
cloneableTags[argsTag$2] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] = cloneableTags[boolTag$2] = cloneableTags[dateTag$2] = cloneableTags[float32Tag$2] = cloneableTags[float64Tag$2] = cloneableTags[int8Tag$2] = cloneableTags[int16Tag$2] = cloneableTags[int32Tag$2] = cloneableTags[mapTag$4] = cloneableTags[numberTag$2] = cloneableTags[objectTag$2] = cloneableTags[regexpTag$2] = cloneableTags[setTag$4] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag$2] = cloneableTags[uint8ClampedTag$2] = cloneableTags[uint16Tag$2] = cloneableTags[uint32Tag$2] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag$2] = cloneableTags[weakMapTag$2] = false;
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value),
        isFunc = tag == funcTag$2 || tag == genTag$1;
    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$2 || tag == argsTag$2 || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  stack || (stack = new Stack());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (isSet(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var CLONE_DEEP_FLAG$1 = 1,
    CLONE_SYMBOLS_FLAG$1 = 4;
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$1);
}

function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;
    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var baseFor = createBaseFor();

function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

function forIn(object, iteratee) {
  return object == null ? object : baseFor(object, castFunction(iteratee), keysIn$1);
}

function dataLayerPush(data, log = true) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
  if (log) {
    console.log({
      dataLayer: window.dataLayer
    });
  }
}
function replacePrefix(val, replacementPrefix) {
  if (typeof val === "string" && val.indexOf("PREFIX:") > -1) {
    return val.replace("PREFIX:", `${replacementPrefix}:`);
  }
  return val;
}
function replacePrefixInObject(object, replacementPrefix) {
  const newObj = cloneDeep(object);
  forIn(newObj, (val, key) => {
    newObj[key] = replacePrefix(val, replacementPrefix);
  });
  return newObj;
}
function replacePrefixInData(object, replacePrefixStr) {
  const newObj = cloneDeep(object);
  if (newObj.data && typeof newObj.data === "object") {
    newObj.data = replacePrefixInObject(newObj.data, replacePrefixStr);
  }
  return newObj;
}
function execEvent(log, events, companyPrefix, eventName, ...args) {
  const dataLayerData = replacePrefixInData(events[eventName](...args), companyPrefix);
  return dataLayerPush(dataLayerData, log);
}
function execCookie(action, actions, companyPrefix, ...args) {
  return actions[action](companyPrefix, ...args);
}
function execCookieEvent(log, events, companyPrefix, eventName, cookies, cookieAction, ...args) {
  const cookie = cookies[cookieAction](companyPrefix, ...args);
  const dataLayerData = replacePrefixInData(events[eventName](cookie, ...args), companyPrefix);
  return dataLayerPush(dataLayerData, log);
}
function checkArray(data) {
  return Array.isArray(data) ? data : [data];
}

function purchaseMapper({
  id,
  revenue,
  tax,
  shipping,
  coupon,
  discount,
  currency
}) {
  return {
    transaction_id: id,
    value: revenue,
    tax,
    shipping,
    coupon,
    discount,
    currency
  };
}
function itemMapper({
  name,
  id,
  price,
  brand,
  category,
  variant,
  quantity,
  coupon,
  affiliation
}) {
  return {
    item_name: name,
    item_id: id,
    price: price || "0.0",
    item_brand: brand || "",
    item_category: category || "",
    item_variant: variant || "",
    quantity: quantity || 1,
    coupon: coupon || "",
    affiliation
  };
}
function data(category, action, label = null) {
  return {
    data: {
      category,
      action,
      label
    }
  };
}
function ecommerce(purchaseData, productData) {
  return {
    ecommerce: { ...purchaseMapper(purchaseData),
      items: checkArray(productData).map(itemMapper)
    }
  };
}

function promoMapper({
  id,
  name,
  creative,
  position
}) {
  return {
    promotion_id: id,
    promotion_name: name || id,
    creative_name: creative,
    creative_slot: position
  };
}
function promotion(promoData) {
  return {
    ecommerce: { ...promoMapper(promoData)
    }
  };
}

function purchaseMapper$1({
  id,
  affiliation,
  revenue,
  tax,
  shipping,
  coupon,
  discount,
  currencyCode
} = {}) {
  return {
    id,
    affiliation,
    revenue: revenue || "0.0",
    tax: tax || "0.0",
    shipping: shipping || "0.0",
    coupon: coupon || "",
    discount: discount || "0.0",
    currencyCode: currencyCode || "USD"
  };
}
function productMapper({
  name,
  id,
  price,
  brand,
  category,
  variant,
  quantity,
  coupon,
  sku
} = {}) {
  return {
    name,
    id,
    price: price || "0.0",
    brand: brand || "",
    category: category || "",
    variant: variant || "",
    quantity: quantity || 1,
    coupon: coupon || "",
    sku: sku || null
  };
}
function products(productData) {
  if (Array.isArray(productData)) {
    return productData.map(prd => productMapper(prd));
  }
  return [productMapper(productData)];
}
function promoMapper$1({
  id,
  name,
  creative,
  position
}) {
  return {
    id,
    name: name || id,
    creative,
    position
  };
}
function promo(promoData) {
  if (Array.isArray(promoData)) {
    return promoData.map(promoMapper$1);
  }
  return [promoMapper$1(promoData)];
}

function user$1({
  userId,
  clientId,
  billingId,
  firstName,
  lastName,
  name,
  email
} = {}) {
  let fixName = name;
  if (!name && (!!firstName || !!lastName)) {
    fixName = `${firstName} ${lastName}`;
  }
  return {
    billingId: billingId || null,
    clientId: clientId || null,
    email: email || null,
    name: fixName || null,
    userId: userId || null,
    emailHash: null
  };
}

function structuredData(category, action, label = null, value = null, nonInteraction = false) {
  return {
    category,
    action: `PREFIX:${action}`,
    label,
    value,
    nonInteraction
  };
}

function structured(category, action, label = null, value = null, nonInteraction = false, mergeData = {}) {
  return {
    event: constants.EVENTS.STRUCTURED,
    data: structuredData(category, action, label, value, nonInteraction),
    ...mergeData
  };
}
function pageview() {
  return {
    event: constants.EVENTS.PAGEVIEW
  };
}
function pageviewVirtual(path, title) {
  return {
    event: constants.EVENTS.VIRTUAL_PAGEVIEW,
    data: {
      path,
      title: title || null
    }
  };
}
function identify(userData = {}) {
  return {
    event: constants.EVENTS.IDENTIFY,
    data: user$1(userData),
    nonInteraction: true
  };
}
function freeTrial(productName = null) {
  return structured("freeTrial", "freeTrial_submitted", productName);
}
function chat(action, label, nonInteraction = false) {
  return structured("chat", action, label, null, nonInteraction);
}
function customerLongevity(longevity) {
  return { ...structured("portal", "user_loggedIn"),
    ...{
      nxCustomer: {
        longevity
      }
    }
  };
}
function chatSales() {
  return chat("chatLink_clicked", "sales");
}
function chatSupport() {
  return chat("chatLink_clicked", "support");
}
function ad(action, label) {
  return structured("marketing", action, label);
}
function phone(action, label) {
  return structured("phoneCalls", action, label);
}
function phoneOutbound(label) {
  return phone("clickToCall_submitted", label);
}
function phoneOutboundSales() {
  return phoneOutbound("sales");
}
function phoneOutboundSupport() {
  return phoneOutbound("support");
}
function phoneInbound() {
  return phone("inboundCall_submitted");
}
function email(distro, action) {
  return structured("emailSubscriptions", action, distro);
}
function webinar(webinarName, action) {
  return structured("webinar", action, webinarName);
}
function invitationDisplayed() {
  return chat(constants.EVENTS.CHAT.INVITATION.DISPLAYED, null, true);
}
function invitationDismissed() {
  return chat(constants.EVENTS.CHAT.INVITATION.DISMISSED);
}
function invitationAccepted() {
  return chat(constants.EVENTS.CHAT.INVITATION.ACCEPTED);
}
function addToCartUA(productData = {}, label = null, currencyCode = "USD") {
  return {
    event: constants.EVENTS.ECOMMERCE.LW,
    data: {
      category: "ecommerce",
      action: "PREFIX:cartItem_added",
      label
    },
    ecommerce: {
      currencyCode,
      add: {
        products: products(productData)
      }
    }
  };
}
function addToCart(productData, label = null, currency = "USD") {
  return {
    event: constants.EVENTS.ECOMMERCE.ADD_TO_CART,
    ...data(constants.EVENTS.ECOMMERCE.LW, constants.EVENTS.ECOMMERCE.ACTIONS.ADD_TO_CART, label),
    ...ecommerce({
      currency
    }, productData)
  };
}
function clearEcommerce() {
  return {
    ecommerce: null
  };
}
function addToCartProductPage(productData = {}, currencyCode = "USD") {
  return addToCartUA(productData, "productPage", currencyCode);
}
function addToCartLink(productData = {}, currencyCode = "USD") {
  return addToCartUA(productData, "cartLink", currencyCode);
}
function addToCartExpress(productData = {}, currencyCode = "USD") {
  return addToCartUA(productData, "express", currencyCode);
}
function removeFromCart(productData, currencyCode = "USD") {
  return {
    event: constants.EVENTS.ECOMMERCE.LW,
    data: {
      category: "ecommerce",
      action: "PREFIX:cartItem_removed"
    },
    ecommerce: {
      currencyCode,
      remove: {
        products: products(productData)
      }
    }
  };
}
function checkout(productData, step = null) {
  return {
    event: constants.EVENTS.ECOMMERCE.LW,
    data: {
      category: "ecommerce",
      action: "PREFIX:checkout_progressed"
    },
    ecommerce: {
      checkout: {
        actionField: {
          step
        },
        products: products(productData)
      }
    }
  };
}
function beginCheckout(productData) {
  return {
    event: constants.EVENTS.ECOMMERCE.BEGIN_CHECKOUT,
    ...data(constants.EVENTS.ECOMMERCE.LW, constants.EVENTS.ECOMMERCE.ACTIONS.CHECKOUT_PROGRESSED),
    ...ecommerce({}, productData)
  };
}
function addPaymentInfo(productData) {
  return {
    event: constants.EVENTS.ECOMMERCE.ADD_PAYMENT_INFO,
    ...data(constants.EVENTS.ECOMMERCE.LW, constants.EVENTS.ECOMMERCE.ACTIONS.CHECKOUT_PROGRESSED),
    ...ecommerce({}, productData)
  };
}
function purchaseCompleted(purchaseData, productData, userData, currencyCode = "USD") {
  return {
    event: constants.EVENTS.ECOMMERCE.LW,
    data: {
      category: "ecommerce",
      action: "PREFIX:purchase_completed",
      user: user$1(userData)
    },
    ecommerce: {
      currencyCode,
      purchase: {
        actionField: purchaseMapper$1(purchaseData),
        products: products(productData)
      }
    }
  };
}
function purchase(purchaseData, productData, userData, currency = "USD") {
  const purchaseDataCurrency = { ...purchaseData
  };
  purchaseDataCurrency.currency = currency;
  return {
    event: constants.EVENTS.ECOMMERCE.PURCHASE,
    user: user$1(userData),
    ...data(constants.EVENTS.ECOMMERCE.LW, constants.EVENTS.ECOMMERCE.ACTIONS.PURCHASE_COMPLETED),
    ...ecommerce(purchaseDataCurrency, productData)
  };
}
function promoView(promoData) {
  return {
    event: constants.EVENTS.ECOMMERCE.LW,
    data: {
      category: "ecommerce",
      action: "PREFIX:promotion_viewed"
    },
    ecommerce: {
      promoView: {
        promotions: promo(promoData)
      }
    }
  };
}
function viewPromotion(promoData) {
  return {
    event: constants.EVENTS.ECOMMERCE.VIEW_PROMOTION,
    ...data(constants.EVENTS.ECOMMERCE.LW, constants.EVENTS.ECOMMERCE.ACTIONS.PROMOTION_VIEWED),
    ...promotion(promoData)
  };
}
function promoClick(promoData) {
  return {
    event: constants.EVENTS.ECOMMERCE.LW,
    data: {
      category: "ecommerce",
      action: "PREFIX:promotion_clicked"
    },
    ecommerce: {
      promoClick: {
        promotions: promo(promoData)
      }
    }
  };
}
function selectPromotion(promoData) {
  return {
    event: constants.EVENTS.ECOMMERCE.SELECT_PROMOTION,
    ...data(constants.EVENTS.ECOMMERCE.LW, constants.EVENTS.ECOMMERCE.ACTIONS.PROMOTION_CLICKED),
    ...promotion(promoData)
  };
}
function experimentVariant(experiment, variant) {
  return {
    event: "lw.structured",
    data: {
      category: "experiment",
      action: "nx:variant_selected",
      label: `${experiment}_${variant}`
    }
  };
}
function navigation(action, label, nonInteraction) {
  return structured("navigation", action, label, null, nonInteraction);
}
const timing = timingData => ({
  event: constants.EVENTS.TIMING,
  timingData
});

var events = /*#__PURE__*/Object.freeze({
  __proto__: null,
  structured: structured,
  pageview: pageview,
  pageviewVirtual: pageviewVirtual,
  identify: identify,
  freeTrial: freeTrial,
  chat: chat,
  customerLongevity: customerLongevity,
  chatSales: chatSales,
  chatSupport: chatSupport,
  ad: ad,
  phone: phone,
  phoneOutbound: phoneOutbound,
  phoneOutboundSales: phoneOutboundSales,
  phoneOutboundSupport: phoneOutboundSupport,
  phoneInbound: phoneInbound,
  email: email,
  webinar: webinar,
  invitationDisplayed: invitationDisplayed,
  invitationDismissed: invitationDismissed,
  invitationAccepted: invitationAccepted,
  addToCartUA: addToCartUA,
  addToCart: addToCart,
  clearEcommerce: clearEcommerce,
  addToCartProductPage: addToCartProductPage,
  addToCartLink: addToCartLink,
  addToCartExpress: addToCartExpress,
  removeFromCart: removeFromCart,
  checkout: checkout,
  beginCheckout: beginCheckout,
  addPaymentInfo: addPaymentInfo,
  purchaseCompleted: purchaseCompleted,
  purchase: purchase,
  promoView: promoView,
  viewPromotion: viewPromotion,
  promoClick: promoClick,
  selectPromotion: selectPromotion,
  experimentVariant: experimentVariant,
  navigation: navigation,
  timing: timing
});

function userExisting(cookieData = {}) {
  let userType = "new";
  const userData = user(cookieData);
  console.log(cookieData);
  if (userData?.clientName) {
    userType = "existing";
  }
  const retData = {};
  retData[constants.DIMENSIONS.USER_TYPE] = userType;
  return retData;
}

var cookieEvents = /*#__PURE__*/Object.freeze({
  __proto__: null,
  userExisting: userExisting
});

const loadScript = (id, nonce) => {
  if (!id) {
    return;
  }
  const win = window;
  const doc = document;
  const script = doc.createElement("script");
  const dl = "dataLayer";
  win[dl] = win[dl] || [];
  win[dl].push({
    event: "gtm.js",
    "gtm.start": new Date().getTime()
  });
  script.async = true;
  script.defer = false;
  if (nonce) {
    script.setAttribute("nonce", nonce);
  }
  script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
  doc.head.appendChild(script);
};
const hasScript = () => Array.from(document.getElementsByTagName("script")).some(script => script.src.includes("googletagmanager"));
function loadGtm(id, nonce) {
  if (!id) {
    throw new Error("Must provide GTM ID to use 'loadGtm' function");
  }
  if (!hasScript()) {
    loadScript(id, nonce);
  }
}

function sendToGoogleTagManager({
  name,
  value,
  delta,
  id
}) {
  dataLayerPush({
    event: constants.EVENTS.VITALS,
    webVitals: {
      name,
      id,
      delta,
      value,
      deltaRounded: Math.round(name === "CLS" ? delta * 1000 : delta),
      valueRounded: Math.round(name === "CLS" ? value * 1000 : value)
    }
  }, false);
}
function report() {
  try {
    onCLS(sendToGoogleTagManager);
    onFID(sendToGoogleTagManager);
    onLCP(sendToGoogleTagManager);
    onTTFB(sendToGoogleTagManager);
    onFCP(sendToGoogleTagManager);
    onINP(sendToGoogleTagManager);
  } catch (err) {
  }
}

var vitals = /*#__PURE__*/Object.freeze({
  __proto__: null,
  report: report
});

class Rendezvous {
  constructor({
    company,
    disableLog
  } = {
    company: "nx",
    disableLog: false
  }) {
    this.company = void 0;
    this.constants = void 0;
    this.cookie = void 0;
    this.cookieEvent = void 0;
    this.cookieEvents = void 0;
    this.cookies = void 0;
    this.disableLog = void 0;
    this.disableLogging = void 0;
    this.enableLogging = void 0;
    this.event = void 0;
    this.events = void 0;
    this.loadGtm = void 0;
    this.vitals = void 0;
    this.company = company || "nx";
    this.disableLog = disableLog;
    this.constants = constants;
    this.cookies = cookies;
    this.cookie = (cookieAction, ...args) => execCookie(cookieAction, this.cookies, this.company, ...args);
    this.events = events;
    this.loadGtm = loadGtm;
    this.event = (eventName, ...args) => {
      execEvent(!this.disableLog, this.events, this.company, eventName, ...args);
    };
    this.eventLink = (eventName, ...args) => {
      execEvent(!this.disableLog, this.events, this.company, eventName, ...args);
      return true;
    };
    this.cookieEvents = cookieEvents;
    this.cookieEvent = (cookieAction, eventName, ...args) => {
      execCookieEvent(!this.disableLog, this.cookieEvents, this.company, eventName, this.cookies, cookieAction, ...args);
    };
    this.vitals = vitals;
    this.dataLayer = data => dataLayerPush(data, !this.disableLog);
  }
}
function init(config) {
  return new Rendezvous(config);
}

export default init;
